import { useCallback } from 'react';
import { MarketplaceRecordWithRatings } from '@kemu-io/kemu-types';
import { ValidPlatformArch } from '@kemu-io/hs-types';
import marketplaceApi from '@src/api/marketplace/marketplaceApi';

interface FetchError {
  message: string;
  status?: number;
}

const useMarketplaceFetch = () => {
  const fetchData = useCallback(async (config: {
    from: number,
    total: number,
    query?: string,
    /** list of publication name to return (eg. 'kemu.io.http, kemu.io.mqtt'). If provided, the version and other filter types are ignored */
    names?: string[],
    version?: string,
    /**
     * If true, the response will include the service's markdown
     */
    markdown?: boolean,
    platform: ValidPlatformArch,
  }): Promise<MarketplaceRecordWithRatings[]> => {

    const { from, total, query, version, platform, markdown, names } = config;
    try {
      const response = await marketplaceApi.getPublications({ from, total, query, version, platform, markdown, names });
      return response.publications;
    } catch (error) {
      const fetchError: FetchError = {
        message: error instanceof Error ? error.message : 'An error occurred while fetching data',
        status: error instanceof Response ? error.status : undefined
      };
      throw fetchError;
    }
  }, []);

  return fetchData;
};

export default useMarketplaceFetch;
